import { WorkspacesStoreActionsClass } from './WorkspacesStoreActionsClass';

const WorkspacesStore: WorkspacesStoreActionsClass = new WorkspacesStoreActionsClass();

export { WorkspacesStore };
